import { createAction, props } from '@ngrx/store'
import { TokenInterface } from '@shared/interfaces/app.state.interfaces'

export const serviciosExternos = createAction(
    '[ServiciosExternos] Token',
    props<{ item: TokenInterface }>()

)

